var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 40,
    viewBox: "0 0 263 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.888,
    cy: 7.74829,
    rx: 128.888,
    ry: 7.74829,
    transform: "matrix(1 0 0 -1 2.61328 37.6091)",
    stroke: "#500E00",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.79,
    cy: 5.6543,
    rx: 88.79,
    ry: 5.6543,
    transform: "matrix(1 0 0 -1 42.7109 14.1125)",
    stroke: "#500E00",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCircles);
export default __webpack_public_path__ + "static/media/whiteCircles.9f7ff2559dadd87caeb96d4c7018e347.svg";
export { ForwardRef as ReactComponent };